import classNames from 'helpers/class-names'
import { FC, ReactNode, SVGProps } from 'react'

interface Props extends SVGProps<SVGSVGElement> {
  className?: string
  children: ReactNode
}

const Svg: FC<Props> = ({ children, className = '', ...props }) => (
  <svg
    className={classNames('pointer-events-none fill-current', className)}
    {...props}>
    {children}
  </svg>
)

export default Svg
